import FileManagerActionType from './fileManagerActionType';

export const getDirectories = (params) => ({
  type: FileManagerActionType.GET_DIRECTORIES,
  payload: { params },
});

export const changeAllDirectoriesLoadingState = (state) => ({
  type: FileManagerActionType.CHANGE_ALL_DIRECTORIES_LOADING_STATE,
  payload: { state },
});

export const saveDirectories = (data) => ({
  type: FileManagerActionType.SAVE_DIRECTORIES,
  payload: { data },
});

export const saveBaseDirectories = (data) => ({
  type: FileManagerActionType.SAVE_BASE_DIRECTORIES,
  payload: { data },
});

export const changeFileManagerLoadingState = (state) => ({
  type: FileManagerActionType.CHANGE_FILE_MANAGER_LOADING_STATE,
  payload: { state },
});

export const getFileTypeGroups = () => ({
  type: FileManagerActionType.GET_FILE_TYPE_GROUPS,
});

export const getFileTypeGroupsSuccess = (data) => ({
  type: FileManagerActionType.GET_FILE_TYPE_GROUPS_SUCCESS,
  payload: { data },
});

export const renamePublicFile = (data) => ({
  type: FileManagerActionType.RENAME_PUBLIC_FILE,
  payload: { data },
});

export const renamePublicDirectory = (data) => ({
  type: FileManagerActionType.RENAME_PUBLIC_DIRECTORY,
  payload: { data },
});

export const changeModalVisibility = (state) => ({
  type: FileManagerActionType.CHANGE_FILE_MANAGER_MODAL_VISIBILITY,
  payload: { state },
});

export const changePopoverVisibility = (state) => ({
  type: FileManagerActionType.CHANGE_FILE_MANAGER_POPOVER_VISIBILITY,
  payload: { state },
});

export const deletePublicFiles = (data) => ({
  type: FileManagerActionType.DELETE_PUBLIC_FILES,
  payload: { data },
});

export const deletePublicDirectory = (data) => ({
  type: FileManagerActionType.DELETE_PUBLIC_DIRECTORY,
  payload: { data },
});

export const changeFileManagerBrandId = (brandId) => ({
  type: FileManagerActionType.CHANGE_FILE_MANAGER_BRAND_ID,
  payload: { brandId },
});

export const resetFileManagerState = () => ({
  type: FileManagerActionType.RESET_FILE_MANAGER_STATE,
});

export const createDirectory = (data) => ({
  type: FileManagerActionType.CREATE_DIRECTORY,
  payload: { data },
});

export const changeDirectoriesEndedStatus = (state) => ({
  type: FileManagerActionType.CHANGE_DIRECTORIES_ENDED_STATUS,
  payload: { state },
});

export const movePublicFiles = (data) => ({
  type: FileManagerActionType.MOVE_PUBLIC_FILES,
  payload: { data },
});

export const getFilesByPaths = (params) => ({
  type: FileManagerActionType.GET_FILES_BY_PATHS,
  payload: { params },
});

export const saveFilesByPaths = (data) => ({
  type: FileManagerActionType.SAVE_FILES_BY_PATHS,
  payload: { data },
});

export const resetFilesByPaths = () => ({
  type: FileManagerActionType.RESET_FILES_BY_PATHS,
});
